module.exports = __webpack_public_path__ + "img/help.5c5b8068.svg";